module.exports = __webpack_public_path__ + "static/media/ic_policy_period.6a1bbed2.svg";